'use client';

import React from 'react';
import { useAccordionDetails } from '../../context/AccordionProvider';
import { twMerge } from 'tailwind-merge';

export interface AccordionDetailsProps {
  children: React.ReactNode;
  index: number;
  className?: string;
  contentClassName?: string;
  sx?: React.CSSProperties;
}

const AccordionDetails = ({
  children,
  index,
  className,
  contentClassName,
  sx,
}: AccordionDetailsProps): React.ReactElement => {
  const { isOpen, size } = useAccordionDetails(index);

  const detailsSizeStyles = {
    sm: 'p-2',
    md: 'p-4',
    lg: 'p-6',
  };

  return (
    <div
      id={`accordion-details-${index}`}
      aria-hidden={!isOpen}
      data-testid={`accordion-details-${index}`}
      className={twMerge(
        'grid transition-[grid-template-rows,opacity] duration-300 ease-in-out',
        isOpen
          ? 'grid-rows-[1fr] opacity-100'
          : 'grid-rows-[0fr] opacity-0 h-0',
        className
      )}
      style={sx}
    >
      <div
        className={twMerge('overflow-hidden', !isOpen && 'pointer-events-none')}
      >
        <div className={twMerge(detailsSizeStyles[size], 'text-base', contentClassName)}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default AccordionDetails;
